module.exports = __webpack_public_path__ + "static/media/gustavo.02c844fd.jpg";